import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';

import NutritionalPanelCatalogCard from 'components/nutritional_panels/NutritionalPanelCatalogCard';
import pointerOnHover from 'lib/css/pointerOnHover';

function NutritionalPanelCatalogView({ nutritionalPanels, panelCount, handleClick }) {
  return (
    <div
      className={classNames(
        css(styles.container),
        pointerOnHover,
        'd-flex flex-wrap justify-content-center',
      )}
    >
      {panelCount ? (
        nutritionalPanels.map(nutritionalPanel => (
          <NutritionalPanelCatalogCard
            key={nutritionalPanel.id}
            nutritionalPanel={nutritionalPanel}
            handleClick={handleClick}
          />
        ))
      ) : (
        <div className="p-5 text-muted h5">No nutritional panels found for the given upload</div>
      )}
    </div>
  );
}
const styles = StyleSheet.create({
  container: {
    minHeight: 500,
  },
});

NutritionalPanelCatalogView.propTypes = {
  nutritionalPanels: PropTypes.array,
  panelCount: PropTypes.number,
  handleClick: PropTypes.func,
};

export default NutritionalPanelCatalogView;
